import { SegmentationIds } from 'constants/segmentation';
import { InputProductType } from 'interfaces/api-input/input-product-type';
import { ProductType } from 'interfaces/product';

export default {
  'common:pieces': 'Stuk',
  'common:allergies': 'Allergieën',
  'common:name': 'Naam',
  'common:name:mandatory': 'Verplicht veld',
  'common:name:optional': 'Optioneel',
  'common:breed': 'Ras',
  'common:age': 'Leeftijd',
  'common:weight': 'Gewicht',
  'common:sterilization': 'Sterilisatie',
  'common:body-condition': 'Lichaamsconditie',
  'common:activity-level': 'Activiteitsniveau',
  'common:need': 'Behoefte',
  'common:back': 'Terug',
  'common:close': 'Sluiten',
  'common:submit': 'Opslaan',
  'common:create': 'Aanmaken',
  'common:and': 'en',
  'common:still': 'Nog',
  'common:add': 'Toevoegen',
  'common:password': 'Wachtwoord',
  'common:password:optional': 'Wachtwoord (Optioneel)',
  'common:selected': 'Geselecteerd',
  'common:buttons:load-more': 'Meer weergeven',
  'common:buttons:learn-more': 'Meer informatie',
  'common:buttons:select': 'Maak een keuze',
  'common:buttons:cancel': 'Annuleren',
  'common:buttons:back': 'Terug',
  'common:buttons:continue': 'Verder',
  'common:add-to-cart': 'In het winkelmandje',
  'common:products': 'Producten',
  'common:promotions': 'Acties',
  'common:price:shipping': 'Verzending',
  'common:price:totalPrice': 'Totaalprijs',
  'common:price:tax': 'incl. BTW',
  'common:price:totalWithTax': 'Totaalbedrag incl. BTW',
  'common:price:discount': 'Korting',
  'common:price:from': 'vanaf',
  'common:product:add': 'Toevoegen',
  'common:product:variant': 'Variant',
  'common:product:quantity': 'Aantal',
  'common:product:interval': 'Interval',
  'common:product:size': 'Maat',
  'common:product:to-the-porduct': 'Naar het product',
  'common:button:confrim': 'Bevestigen',
  'common:input:required': 'Verplicht veld',
  'common:input:street:number-required': 'Straat moet minstens een nummer bevatten',
  'common:input:street:letter-required': 'Straat moet minstens een letter bevatten',
  'common:input:street:min-length': 'Straat moet minstens 2 tekens lang zijn',
  'common:product:out-of-stock': 'Uitverkocht',
  'common:product:image-placeholder': 'Productafbeelding',
  'common:alt': 'Afbeelding voor',
  'common:product:bundle-contains': '<b>Proefpakket bevat</b> {productsList}',
  'common:address:shipping-address': 'Bezorgadres',
  'common:address:billing-address': 'Factuuradres',
  'common:payment:payment-method': 'Betaalmethode',
  'common:unknown': 'Onbekend',
  'common:loading': 'Laden...',
  'common:country:de': 'Duitsland',
  'common:country:at': 'Oostenrijk',
  'common:country:ch': 'Zwitserland',
  'common:country:nl': 'Nederland',
  'common:for-dogs': 'Voor honden',
  'common:dogs': 'Honden',
  'common:for-cats': 'Voor katten',
  'common:cats': 'Katten',
  'common:pet-type': 'Diersoort',
  'common:pet-type:dog': 'Hond',
  'common:pet-type:cat': 'Kat',
  'common:birthday': 'Verjaardag',
  'common:add-item': 'Toevoegen',
  'common:remove-item': 'Verwijderen',
  'common:understood': 'Begrepen',
  'common:saved': 'Opgeslagen',
  'common:error:failed-to-save': 'Opslaan mislukt. Probeer het later opnieuw.',
  'common:undo': 'Ongedaan maken',
  'common:feed-type': 'Voersoort',
  'common:taste': 'Smaak',
  'common:consistency': 'Consistentie',
  'common:snack': 'Snacksoort',

  'common:shop-switcher:title': 'Ben je op de juiste weg?',
  'common:shop-switcher:stay': 'Nee, hier blijven',

  'common:shop-switcher:to:DE:button': 'Ja, naar de Duitse shop',
  'common:shop-switcher:to:DE:text':
    'Op petsdeli.de zijn leveringen naar Duitsland en Oostenrijk mogelijk. Wil je naar de Duitse shop overschakelen?',

  'common:shop-switcher:to:CH:button': 'Ja, naar de Zwitserse shop',
  'common:shop-switcher:to:CH:text':
    'Op petsdeli.ch zijn leveringen naar Zwitserland mogelijk. Wil je naar de Zwitserse shop overschakelen?',

  'common:shop-switcher:to:NL:button': 'Ja, naar de Nederlandse shop',
  'common:shop-switcher:to:NL:text':
    'Op petsdeli.nl zijn leveringen naar Nederland mogelijk. Wil je naar de Nederlandse shop overschakelen?',

  'common:tabs-accordeon:product-info': 'Productinformatie',
  'common:tabs-accordeon:product-info:plural': 'Productinformatie',
  'common:product-info-preview:read-more': 'Meer weergeven',
  'common:product-info-preview:read-less': 'Minder weergeven',
  'common:tabs-accordeon:badge-new': 'Nieuw',
  [`common:breed:${SegmentationIds.Bulldog}`]: 'Bulldoggen',
  [`common:breed:${SegmentationIds.Chihuahua}`]: 'Chihuahuas',
  [`common:breed:${SegmentationIds.Dachshund}`]: 'Teckels',
  [`common:breed:${SegmentationIds.Havanese}`]: 'Maltezers',
  [`common:breed:${SegmentationIds.Poodle}`]: 'Poedels',
  [`common:breed:${SegmentationIds.Retriever}`]: 'Retrievers',
  [`common:breed:${SegmentationIds.ShepherdDog}`]: 'Herdershonden',
  [`common:breed:${SegmentationIds.Spitz}`]: 'Spitz',
  [`common:breed:${SegmentationIds.Terrier}`]: 'Terriërs',
  [`common:breed:${SegmentationIds.Herdingdog}`]: 'Herdershonden',
  [`common:breed:${SegmentationIds.MixedLarge}`]: 'Kruising (groot)',
  [`common:breed:${SegmentationIds.MixedSmall}`]: 'Kruising (klein)',
  [`common:breed:${SegmentationIds.OtherBreed}`]: 'Ander ras',

  [`common:age:${SegmentationIds.Welpe}`]: 'Pup',
  [`common:age:${SegmentationIds.DogAdult}`]: 'Adult',
  [`common:age:${SegmentationIds.DogSenior}`]: 'Senior',
  [`common:age:${SegmentationIds.Kitten}`]: 'Kitten',
  [`common:age:${SegmentationIds.CatAdult}`]: 'Adult',
  [`common:age:${SegmentationIds.CatSenior}`]: 'Senior',

  [`common:allergy:${SegmentationIds.GrainFree}`]: 'Granen',
  [`common:allergy:${SegmentationIds.Beef}`]: 'Rund',
  [`common:allergy:${SegmentationIds.Chicken}`]: 'Kip',
  [`common:allergy:${SegmentationIds.Duck}`]: 'Eend',
  [`common:allergy:${SegmentationIds.Fish}`]: 'Vis',
  [`common:allergy:${SegmentationIds.Lamb}`]: 'Lam',
  [`common:allergy:${SegmentationIds.Horse}`]: 'Paard',
  [`common:allergy:${SegmentationIds.Goat}`]: 'Geit',
  [`common:allergy:${SegmentationIds.SweetPotato}`]: 'Zoete aardappelen',
  [`common:allergy:${SegmentationIds.Potato}`]: 'Aardappelen',
  [`common:allergy:${SegmentationIds.Poultry}`]: 'Gevogelte',
  [`common:allergy:${SegmentationIds.Deer}`]: 'Hert',
  [`common:allergy:${SegmentationIds.Rabbit}`]: 'Konijn',
  [`common:allergy:${SegmentationIds.Veal}`]: 'Kalf',
  [`common:allergy:${SegmentationIds.Kangaroo}`]: 'Kangoeroe',
  [`common:allergy:${SegmentationIds.Salmon}`]: 'Zalm',
  [`common:allergy:${SegmentationIds.Turkey}`]: 'Kalkoen',
  [`common:allergy:${SegmentationIds.Tuna}`]: 'Tonijn',
  [`common:allergy:${SegmentationIds.Game}`]: 'Wild',
  [`common:allergy:${SegmentationIds.Pork}`]: 'Varken',

  [`common:product-type:${ProductType.WetFood}`]: 'Natvoer',
  [`common:product-type:${ProductType.DryFood}`]: 'Droogvoer',
  [`common:product-type:${ProductType.FoodSupplement}`]: 'Voedingssupplement',
  [`common:product-type:${ProductType.Med}`]: 'Med',
  [`common:product-type:${ProductType.FreshMenus}`]: 'BARF',
  [`common:product-type:${ProductType.Snacks}`]: 'Snacks',
  [`common:product-type:${ProductType.Accessories}`]: 'Accessoires',
  [`common:product-type:${ProductType.Gift}`]: 'Cadeau',
  [`common:product-type:${ProductType.Care}`]: 'Verzorging',
  [`common:product-type:${ProductType.Testpaket}`]: 'Proefpakket',
  [`common:product-type:${InputProductType.WetFood}`]: 'Natvoer',
  [`common:product-type:${InputProductType.DryFood}`]: 'Droogvoer',
  [`common:product-type:${InputProductType.FoodSupplement}`]: 'Voedingssupplement',
  [`common:product-type:${InputProductType.Med}`]: 'Med',
  [`common:product-type:${InputProductType.Barf}`]: 'BARF',
  [`common:product-type:${InputProductType.Snacks}`]: 'Snacks',
  [`common:product-type:${InputProductType.Accessories}`]: 'Accessoires',
  [`common:product-type:${InputProductType.Gift}`]: 'Cadeau',
  [`common:product-type:${InputProductType.Care}`]: 'Verzorging',
  [`common:product-type:${InputProductType.TestPackage}`]: 'Proefpakket',
  'common:bestseller': 'Bestseller',

  'common:hero-filter:nassfutter': 'Natvoer',
  'common:hero-filter:trockenfutter': 'Droogvoer',
  'common:hero-filter:barf': 'BARF',
  'common:hero-filter:snacks': 'Snacks',
  'common:hero-filter:all': 'Alle',

  'common:one-time-purchase:title': 'Eenmalige levering',

  'common:pet-profile:age-selector:title': 'Leeftijd',
  'common:pet-profile:age-selector:chip:welpe': 'Pup (0-1 jaar)',
  'common:pet-profile:age-selector:chip:dog-adult': 'Adult (1-8 jaar)',
  'common:pet-profile:age-selector:chip:senior': 'Senior (vanaf 8 jaar)',
  'common:pet-profile:age-selector:chip:kitten': 'Kitten (0-1 jaar)',
  'common:pet-profile:age-selector:chip:adultcat': 'Adult (1-10 jaar)',
  'common:pet-profile:age-selector:chip:seniorcat': 'Senior (10+ jaar)',
  'common:pet-profile:age-selector:desktop-age-selector:welpe': 'Junior',
  'common:pet-profile:age-selector:desktop-age-selector:description:welpe': 'tot 1 jaar',
  'common:pet-profile:age-selector:desktop-age-selector:dog-adult': 'Adult',
  'common:pet-profile:age-selector:desktop-age-selector:description:dog-adult':
    'tussen 1 en 8 jaar',
  'common:pet-profile:age-selector:desktop-age-selector:senior': 'Senior',
  'common:pet-profile:age-selector:desktop-age-selector:description:senior': 'vanaf 8 jaar',
  [`common:pet-profile:age-selector:desktop-age-selector:${SegmentationIds.Kitten}`]: 'Kitten',
  [`common:pet-profile:age-selector:desktop-age-selector:${SegmentationIds.CatAdult}`]: 'Adult',
  [`common:pet-profile:age-selector:desktop-age-selector:${SegmentationIds.CatSenior}`]: 'Senior',
  [`common:pet-profile:age-selector:desktop-age-selector:description:${SegmentationIds.Kitten}`]:
    'tot 1 jaar',
  [`common:pet-profile:age-selector:desktop-age-selector:description:${SegmentationIds.CatAdult}`]:
    'tussen 1 en 10 jaar',
  [`common:pet-profile:age-selector:desktop-age-selector:description:${SegmentationIds.CatSenior}`]:
    '10+ jaar',
  'common:pet-profile:sterilization-selector:title': 'Sterilisatiestatus',
  'common:pet-profile:sterilization-selector:description:yes': 'Gesteriliseerd/Gecastreerd',
  'common:pet-profile:sterilization-selector:description:no': 'Niet gesteriliseerd/gecastreerd',
  'common:pet-profile:sterilization-selector:chip:yes': 'Ja',
  'common:pet-profile:sterilization-selector:chip:no': 'Nee',
  'common:pet-profile:body-condition-selector:chip:1': 'Zeer slank',
  'common:pet-profile:body-condition-selector:chip:2': 'Iets te slank',
  'common:pet-profile:body-condition-selector:chip:3': 'Ideaal in vorm',
  'common:pet-profile:body-condition-selector:chip:4': 'Iets mollig',
  'common:pet-profile:body-condition-selector:chip:5': 'Goed gevuld',
  'common:pet-profile:body-condition-selector:description:1': 'Zeer slank',
  'common:pet-profile:body-condition-selector:description:2': 'Iets te slank',
  'common:pet-profile:body-condition-selector:description:3': 'Ideaal in vorm',
  'common:pet-profile:body-condition-selector:description:4': 'Iets mollig',
  'common:pet-profile:body-condition-selector:description:5': 'Goed gevuld',
  'common:pet-profile:activity-level-selector:chip:low': 'Weinig actief',
  'common:pet-profile:activity-level-selector:chip:medium': 'Normaal actief',
  'common:pet-profile:activity-level-selector:chip:high': 'Zeer actief',
  'common:pet-profile:activity-level-selector:description:low': 'Weinig actief',
  'common:pet-profile:activity-level-selector:description:medium': 'Normaal actief',
  'common:pet-profile:activity-level-selector:description:high': 'Zeer actief',
  'common:pet-profile:breed-selector:title': 'Kies een ras:',
  [`common:pet-profile:breed-selector:${SegmentationIds.Bulldog}`]: 'Bulldog',
  [`common:pet-profile:breed-selector:${SegmentationIds.Chihuahua}`]: 'Chihuahua',
  [`common:pet-profile:breed-selector:${SegmentationIds.Dachshund}`]: 'Teckel',
  [`common:pet-profile:breed-selector:${SegmentationIds.Havanese}`]: 'Havanezer & Maltezer',
  [`common:pet-profile:breed-selector:${SegmentationIds.Herdingdog}`]: 'Herdershond',
  [`common:pet-profile:breed-selector:${SegmentationIds.MixedLarge}`]: 'Kruising (groot)',
  [`common:pet-profile:breed-selector:${SegmentationIds.MixedSmall}`]: 'Kruising (klein)',
  [`common:pet-profile:breed-selector:${SegmentationIds.Poodle}`]: 'Poedel & Poedelmix',
  [`common:pet-profile:breed-selector:${SegmentationIds.Retriever}`]: 'Retriever',
  [`common:pet-profile:breed-selector:${SegmentationIds.ShepherdDog}`]: 'Herdershond',
  [`common:pet-profile:breed-selector:${SegmentationIds.Spitz}`]: 'Spitz',
  [`common:pet-profile:breed-selector:${SegmentationIds.Terrier}`]: 'Terriër',
  [`common:pet-profile:breed-selector:${SegmentationIds.OtherBreed}`]: 'Ander ras',
  'common:pet-profile:needs-selector:title': 'Behoeften:',
  'common:pet-profile:needs-selector:pickyeater': 'Kieskeurig eetgedrag',
  'common:pet-profile:needs-selector:overweight': 'Overgewicht',
  'common:pet-profile:needs-selector:intolerance': 'Allergieën & intoleranties',
  'common:pet-profile:needs-selector:intolerance-subtitle':
    'Kies de ingrediënten die je wilt vermijden (optioneel):',
  'common:pet-profile:needs-selector:digestion': 'Spijsverteringsproblemen',
  'common:pet-profile:needs-selector:skin-fur': 'Huid- & vachtproblemen',
  'common:pet-profile:needs-selector:pickyeater-description': 'Kieskeurig, onrust, winderigheid',
  'common:pet-profile:needs-selector:overweight-description': 'Traagheid, geen taille zichtbaar',
  'common:pet-profile:needs-selector:intolerance-description': 'Krabben, diarree, rommelende maag',
  'common:pet-profile:needs-selector:digestion-description':
    'Diarree, winderigheid, drukgevoeligheid',
  'common:pet-profile:needs-selector:skin-fur-description': 'Krabben, likken, kale plekken',
  'common:pet-profile:needs-selector:prevention': 'Gezondheidspreventie',
  'common:pet-profile:needs-selector:prevention-description':
    'Immuunsysteem, spijsverteringsbalans, vitaliteit, gewrichten',
  [`common:pet-profile:needs-selector:${SegmentationIds.CatPickyEater}`]: 'Kieskeurige eter',
  [`common:pet-profile:needs-selector:${SegmentationIds.CatDigestion}`]: 'Spijsverteringsproblemen',
  [`common:pet-profile:needs-selector:${SegmentationIds.CatOverweight}`]: 'Overgewicht',
  [`common:pet-profile:needs-selector:${SegmentationIds.SkinFurCat}`]: 'Huid- & vachtproblemen',
  [`common:pet-profile:needs-selector:${SegmentationIds.ImmuneSystem}`]: 'Immunity+',
  [`common:pet-profile:needs-selector:${SegmentationIds.IntoleranceCat}`]:
    'Allergieën / intoleranties',
  [`common:pet-profile:needs-selector:${SegmentationIds.HairballHelp}`]: 'Haarbal-hulp',
  [`common:pet-profile:needs-selector:${SegmentationIds.CatPickyEater}-description`]:
    'Kieskeurig, onrust, winderigheid',
  [`common:pet-profile:needs-selector:${SegmentationIds.CatDigestion}-description`]:
    'Diarree, winderigheid, verstopping, gebrek aan eetlust',
  [`common:pet-profile:needs-selector:${SegmentationIds.CatOverweight}-description`]:
    'Traagheid, ontbrekende taille, gewichtstoename',
  [`common:pet-profile:needs-selector:${SegmentationIds.ImmuneSystem}-description`]:
    'Ondersteuning van het immuunsysteem',
  [`common:pet-profile:needs-selector:${SegmentationIds.IntoleranceCat}-description`]:
    'Krabben, diarree, rommelende maag',
  [`common:pet-profile:needs-selector:${SegmentationIds.SkinFurCat}-description`]:
    'Krabben, likken, kale plekken',
  [`common:pet-profile:needs-selector:${SegmentationIds.HairballHelp}-description`]:
    'Ondersteunt de vertering van haarballen',
  'common:pet-profile:allergy': 'Intolerantie',
  'common:show-more': 'Meer weergeven',
  'common:show-less': 'Minder weergeven',
};
